// lbl.home
export const home = {
    welcome_bk: "ยินดีต้อนรับสู่ เบอร์เกอร์คิง",
    start_app: "เริ่มใช้แอปพลิเคชัน  ",
    welcome_burgerking: "ยินดีต้อนรับสู่  เบอร์เกอร์คิง",
};
